module.exports = __webpack_public_path__ + "media/banner.d2c66bd7.mp4";